/**
 * Amber "not calibrated" mark next to a target (referee pickers). Shown
 * only on ranges with a camera; picking the target stays possible — the
 * round then simply gets no camera hit positions.
 */
export function UncalibratedBadge({ compact = false }: { compact?: boolean }) {
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-full border border-amber-500/60 bg-amber-500/15 px-2 py-0.5 text-xs font-semibold text-amber-300"
      title="Diese Scheibe ist an diesem Schießstand nicht kalibriert — keine Kamera-Treffererkennung."
    >
      <span aria-hidden>📷⚠</span>
      {compact ? 'nicht kalibriert' : 'Kamera nicht kalibriert'}
    </span>
  );
}
